import React, { memo } from 'react';
import { selectErrorLabels, selectIsFullCart } from 'features/carrello/carrelloSelectors';
import { useAppDispatch, useTypedSelector } from 'lib/centralStore';

import { BannerInformationPropsType } from 'components/bannerInformation';
import { CarrelloFooterContainer } from 'features/carrello/carrelloFooterContainer';
import { CarrelloFooterSingolaMultipla } from 'features/carrello/carrelloFooterSingolaMultipla';
import { MovimentiTipoScommessaEnum } from 'types/swagger';
import { VirtualTicketItem } from 'features/virtual/components/virtualTicket/components/virtualTicketItem/VirtualTicketItem';
import { dismissChangedQuoteWarning } from 'features/virtual/components/virtualTicket/utils/calcoloCarrello/utils';
import { selectErrori } from 'features/virtual/components/virtualTicket/virtualTicketSelectors';
import styles from './VirtualTicketSingolaMultipla.module.scss';

export type VirtualTicketSingolaMultiplaProps = {
  bonus: number;
  isMultipla?: boolean;
  avvenimentiKeys: string[];
  quotaTotale: number;
  possibileVincitaMin: number;
  possibileVincitaMinWithBonus: number;
};

export const VirtualTicketSingolaMultipla = memo(function VirtualTicketSingolaMultipla({
  bonus,
  isMultipla,
  avvenimentiKeys,
  quotaTotale,
  possibileVincitaMin,
  possibileVincitaMinWithBonus,
}: VirtualTicketSingolaMultiplaProps) {
  const dispatch = useAppDispatch();
  const errori = useTypedSelector(selectErrori);
  const isFullCart = useTypedSelector(selectIsFullCart);
  const errorsLabels = useTypedSelector(selectErrorLabels);

  return (
    <React.Fragment>
      {isFullCart && (
        <div className={styles.wrapper}>
          {avvenimentiKeys?.map((avvenimentoId) => {
            return <VirtualTicketItem key={`virtual-ticket-${avvenimentoId}-multipla`} avvenimentoId={avvenimentoId} />;
          })}
        </div>
      )}

      <CarrelloFooterContainer
        type={MovimentiTipoScommessaEnum.Virtual}
        errors={
          errori.erroriCarrello?.length > 0 && Array.isArray(errori.erroriCarrello)
            ? Array.from(errori.erroriCarrello, (errore) => {
                const foundError = errorsLabels.find((errorLabel) => errorLabel.key === errore.type);
                return {
                  type: foundError?.tipo as BannerInformationPropsType['type'],
                  text: errore.value
                    ? foundError?.value.replace(/{{valore}}/, errore.value.toString())!
                    : foundError?.value!,
                  visible: true,
                  layoutType: 'small',
                };
              })
            : errori.erroriVendita?.length > 0 && Array.isArray(errori.erroriVendita)
            ? Array.from(errori.erroriVendita, (errore) => {
                const foundError = errorsLabels.find((errorLabel) =>
                  typeof errore === 'string' ? errorLabel.key === errore : errorLabel.key === errore.type
                );
                return {
                  type: foundError?.tipo as BannerInformationPropsType['type'],
                  text: foundError?.value!,
                  visible: true,
                  layoutType: 'small',
                  isDismissible: true,
                  actionOnDismiss: dismissChangedQuoteWarning({
                    dispatcher: dispatch,
                    error: foundError!,
                  }),
                };
              })
            : undefined
        }
      >
        <CarrelloFooterSingolaMultipla
          bonus={bonus}
          isMultipla={isMultipla}
          quotaTotale={quotaTotale}
          possibileVincita={possibileVincitaMin}
          possibileVincitaconBonus={possibileVincitaMinWithBonus}
          type={MovimentiTipoScommessaEnum.Virtual}
        />
      </CarrelloFooterContainer>
    </React.Fragment>
  );
});